<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="24">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">发货单废单列表</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <PreSaleDeliveryDetail ref="preSaleDeliveryDetailModal" />

    </div>
</template>

<script>

import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import PreSaleDeliveryDetail from './preSale-delivery-detail';
import { getPreSaleDeliveryListOld, updatePreSaleDeliveryByUuid, closePreSaleDeliveryByUuid, canclePreSaleDeliveryByUuid } from '@/api/modules/preSale-management/preSale-delivery';

export default {
    name: 'PreSaleDeliveryList',
    components: {
        StandPaginationTable,
        SearchCard,
        PreSaleDeliveryDetail
    },
    data() {
        return {
            userType:'F',
            innerSpin: false,
            mainTable: {
                tableColumns: [
                    { title: '废单编号', key: 'preSaleDeliveryRecordCode', align: 'center' },
                    { title: '发货单号', key: 'preSaleDeliveryRecordCodeOld', align: 'center' },
                    { title: '关联定金单号', key: 'preSaleDeliveryRecordRelateOrderRecordCode', align: 'center' },
                    { title: '会员号', key: 'userName', align: 'center' },
                    { title: '会员名', key: 'userPersonName', align: 'center' },
                    { title: '客戶经理', key: 'userCustomerManagerName', align: 'center' },
                    { title: '销售数量', key: 'preSaleDeliveryRecordTotalQuantity', align: 'center' },
                    { title: '销售金额', key: 'totalOrderCost', align: 'center' },
                    { title: '佣金比例(%)', key: 'salesAssociateCommissionPercent', align: 'center' },
                    { title: '发货苗场', key: 'seedFarmName', align: 'center' },
                    {
					    title: '发货单状态', key: 'preSaleDeliveryRecordStatusOld', align: 'center',
					    renderHeader: (h, { column, index }) => {
					        return h('div',
					            [
					                h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.checkStatusOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '4px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onCheckStatusOrderChange();
                                            }
                                        }
                                    })
					            ]
					        );
					    },
					    render: (h, params) => {
					        return h('span', {}, params.row.preSaleDeliveryRecordStatusOld === 1 ? '已发货' : params.row.preSaleDeliveryRecordStatusOld === 0 ? '未发货':params.row.preSaleDeliveryRecordStatusOld === 3 ? '撤单':'关闭');
					    }
                    },
                    { title: '转运站', key: 'distributionStationName', align: 'center' },
                    //{ title: '转运站发货状态', key: 'stationDeliveryType',  width: 100, align: 'center', sortable：'custom' },
                    { title: '转运站状态', key: 'stationDeliveryType', align: 'center',
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.deliveryOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '4px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onDeliveryChange();
                                            }
                                        }
                                    })
                                ]
                            );
                        }
                    },
                    { title: '客户收货状态', key: 'preSaleDeliveryRecordReceivingStatus', align: 'center',
                        renderHeader: (h, { column, index }) => {
					        return h('div',
					            [
					                h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.receiveOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '4px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onReceiveOrderChange();
                                            }
                                        }
                                    })
					            ]
					        );
					    },
					    render: (h, params) => {
					        return h('span', {}, params.row.preSaleDeliveryRecordReceivingStatus === 1 ? '已收货' : '未收货');
					    }
                    },
                    { title: '是否退货', key: 'isRefundGoods', align: 'center',
                        render: (h, params) => {
                            return h('span', {}, params.row.isRefundGoods === 1 ? '已退货' : '未退货');
                        }
                    },
                    { title: '物流公司', key: 'preSaleDeliveryRecordLogisticsCompanyName', align: 'center' },
                    { title: '发货日期', key: 'preSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate) },
                    { title: '制单时间', key: 'preSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.preSaleDeliveryRecordCreateAt) },
                    { title: '客户备注', key: 'customerMsg', align: 'center' },
                    { title: '定单备注', key: 'orderRemark', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width:100,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.preSaleDeliveryDetailModal.showModal(params.row.preSaleDeliveryRecordUuid);
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '废单编号', type: 'Input', value: '', name: 'psdr.preSaleDeliveryRecordCode', sql: 'like' },
                    { label: '发货单号', type: 'Input', value: '', name: 'psdrOld.preSaleDeliveryRecordCode', sql: 'like' },
                    { label: '定金单号', type: 'Input', value: '', name: 'psdr.preSaleDeliveryRecordRelateOrderRecordCode', sql: 'like' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'psdr.preSaleDeliveryRecordDeliveryDate', sql: 'dateBetween' },
                    { label: '发货苗场', type: 'Input', value: '', name: 'psdr.seedFarmName', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(psdr.userName, psdr.userPersonName) ', sql: 'like' },
                    {
					    label: '发货单状态',
					    type: 'Select',
					    value: [],
					    name: 'psdrOld.preSaleDeliveryRecordStatus',
					    sql: 'in',
					    options: [{ key: '未发货', value: 0 }, { key: '已发货', value: 1 }, { key: '关闭', value: 2 }, { key: '撤单', value: 3 }]
                    },
                    {
					    label: '转运站发货状态',
					    type: 'Select',
					    value: [],
					    name: 'psdr.stationDeliveryType',
					    sql: 'in',
					    options: [{ key: '未发货', value: '未发货' }, { key: '已发货', value: '已发货' }]
                    },
                    {
					    label: '客户收货状态',
					    type: 'Select',
					    value: [],
					    name: 'psdr.preSaleDeliveryRecordReceivingStatus',
					    sql: 'in',
					    options: [{ key: '未收货', value: 0 }, { key: '已收货', value: 1 }]
                    }
                ]
            },
            checkStatusOrder: 0,
            deliveryOrder: 0,
            receiveOrder: 0,

            ruleValidate:{
                revokeRemarks: [
				    { required: true, message: '请输入撤单备注!', trigger: 'blur' }
                ]
            }
        };
    },
    // props: {
    //     userType: { type: String, default: '' }
    // },
    mounted() {
        this.init();
    },
    computed: {
        checkStatusOrderIcon() {
            if (this.checkStatusOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.checkStatusOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        deliveryOrderIcon() {
            if (this.deliveryOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.deliveryOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        receiveOrderIcon() {
            if (this.receiveOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.receiveOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        }
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        closeOrder(recordUuid){
            this.$Modal.confirm({
				  title: "是否确认关闭该发货单？",
				  content: "",
				  onOk: async () => {
					  this.mainTable.loading = true;
					  closePreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid:recordUuid }).then(res => {
						  this.mainTable.loading = false;
						  if (res.code === 0) {
							  this.getMainTableRecords();
							  this.$Message.success('成功关闭该发货单！');
						  }
					  });
				  }
            });
        },
        receivingChange(recordUuid){
            this.$Modal.confirm({
				  title: "是否确认客户已收货？",
				  content: "",
				  onOk: async () => {
					  this.mainTable.loading = true;
					  updatePreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid:recordUuid }).then(res => {
						  this.mainTable.loading = false;
						  if (res.code === 0) {
							  this.getMainTableRecords();
							  this.$Message.success('确认客户已收货');
						  }
					  });
				  }
            });
        },
        onDeliveryChange() {
            this.deliveryOrder = (this.deliveryOrder + 1) % 3;
            this.getMainTableRecords();
        },
        onCheckStatusOrderChange() {
            this.checkStatusOrder = (this.checkStatusOrder + 1) % 3;
            this.getMainTableRecords();
        },
        onReceiveOrderChange() {
            this.receiveOrder = (this.receiveOrder + 1) % 3;
            this.getMainTableRecords();
        },
        setOrderCondition() {
            this.mainTable.tableSearch.order.enable = false;
            this.mainTable.tableSearch.order.conditions = [];

            if (this.checkStatusOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordStatus",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.checkStatusOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordStatus",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

            if (this.deliveryOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "stationDeliveryType",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.deliveryOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "stationDeliveryType",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

            if (this.receiveOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordReceivingStatus",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.receiveOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordReceivingStatus",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

        },
        onUserTypeChage(e){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.setOrderCondition();
            getPreSaleDeliveryListOld(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onRefundGoodsClose(){
            this.getMainTableRecords();
        }
    }
};
</script>

<style scoped>
</style>
